/**
 * List of events used by booking steps widget
 *
 */
export const bookedServicesList = {
  BOOKED_SERVICES_LIST_SERVICE_SELECTED: 'bookedServicesList.serviceSelected',
  BOOKED_SERVICES_LIST_SERVICE_NOT_SELECTED: 'bookedServicesList.serviceNotSelected',
  BOOKED_SERVICES_LIST_SERVICE_NOT_AVAILABLE: 'bookedServicesList.serviceNotAvailable'
}
